export const BROKER_PRE_REGISTER_STATUS = {
  PENDING: 'PENDENTE',
  APPROVED: 'APROVADO',
  REJECTED: 'RECUSADO',
  MANUAL_REGISTRATION: 'CADASTRO MANUAL',
  ERROR: 'ERRO',
  PENDING_DOCUMENTATION: 'DOCUMENTAÇÃO PENDENTE',
  EXTERNAL_REGISTRATION: 'CADASTRO EXTERNO',
};

export const BROKER_PRE_REGISTER_LABELS_COLOR_BY_STATUS = {
  PENDENTE: 'danger',
  APROVADO: 'success',
  RECUSADO: 'dark',
  'CADASTRO MANUAL': 'primary',
  ERRO: 'danger',
  'DOCUMENTAÇÃO PENDENTE': 'warning',
  'CADASTRO EXTERNO': '#2b273f',
};
export const YES_VALUE = 'sim';
export const NO_VALUE = 'não';

export const YES_AND_NO_OPTIONS = [
  { label: YES_VALUE, value: YES_VALUE, id: 1 },
  { label: NO_VALUE, value: NO_VALUE, id: 2 },
];
export const BROKER_PRE_REGISTER_ACTIONS = {
  APPROVE: 'approve',
  REJECT: 'reject',
  UPDATE: 'update',
  PENDING_DOCUMENTATION: 'pending_documentation',
  EXTERNAL_REGISTRATION: 'external_registration',
};

export const BROKER_PRE_REGISTER_FORM_FIELDS = [
  'id',
  'socialName',
  'cpfCnpj',
  'iss',
  'municipalRegistration',
  'susepCode',
  'partnerName',
  'partnerCpf',
  'partner2Name',
  'partner2Cpf',
  'isNationalSimple',
  'belongsToConsultancy',
  'consultancyName',
  'administrationContactName',
  'administrationContactEmail',
  'administrationContactCpf',
  'administrationContactCellphone',
  'calculatorContactName',
  'calculatorContactCpf',
  'calculatorContactEmail',
  'calculatorContactCellphone',
  'address',
  'postalCode',
  'addressNumber',
  'addressComplement',
  'addressNeighborhood',
  'addressCity',
  'addressState',
  'bank',
  'bankAccount',
  'bankAgency',
  'pixKey',
  'technicalResponsibleName',
  'technicalResponsibleCpf',
  'technicalResponsibleSusepCode',
  'annualProduction',
  'attachments',
  'portal',
  'brokerLogoUrl',
  'observations',
];
